import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { User, ArrowRight, ShieldCheck, CheckCircle } from 'lucide-react';

// Página pública "Esqueci a senha" (etapa 1 — solicitar).
// O usuário informa o CPF e recebe por WhatsApp um link de redefinição.
// A resposta do backend é SEMPRE neutra (anti-enumeração): exibimos a mesma
// mensagem tenha o CPF ou não, para não virar oráculo de "esse CPF existe?".
function EsqueciSenha() {
  const [cpf, setCpf] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [mensagem, setMensagem] = useState(''); // preenchido = tela de confirmação
  const navigate = useNavigate();

  // Máscara leve de CPF (000.000.000-00) só para leitura; ao enviar mandamos
  // os dígitos crus (o backend normaliza de qualquer forma).
  const formatarCpf = (valor) => {
    const d = valor.replace(/\D/g, '').slice(0, 11);
    return d
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setEnviando(true);
    try {
      const response = await fetch('/api/reset-senha/solicitar', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ cpf: cpf.replace(/\D/g, '') }),
      });
      const data = await response.json();
      // Mostramos a mensagem do backend (neutra e fixa). Mesmo em erro de rede,
      // caímos num texto genérico — nunca revelamos estado do CPF.
      setMensagem(data.message || 'Se o CPF estiver ativo, enviamos um link no WhatsApp cadastrado.');
    } catch (err) {
      setMensagem('Se o CPF estiver ativo, enviamos um link no WhatsApp cadastrado. Não recebeu em até 3 horas? Solicite ao Gerente do Restaurante fazer uma solicitação no site em atualização de cadastro que está no módulo de Recursos Humanos.');
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="login-page-wrapper">
      <div className="login-premium-card">

        {/* Lado Esquerdo - Branding */}
        <div className="login-brand-side">
          <div className="brand-content">
            <img src="/icon-logotipo.png" alt="Grupo Correia" className="brand-logo" />
          </div>
        </div>

        {/* Lado Direito - Formulário / Confirmação */}
        <div className="login-form-side">
          {mensagem ? (
            // --- Tela de confirmação (resposta neutra) ---
            <div className="form-header" style={{ marginBottom: 0 }}>
              <div className="icon-badge">
                <CheckCircle size={28} color="#BC0005" />
              </div>
              <h3>Solicitação recebida</h3>
              <p style={{ marginTop: 16, lineHeight: 1.6 }}>{mensagem}</p>
              <button
                onClick={() => navigate('/login')}
                className="btn-primary-login"
                style={{ marginTop: 28 }}
              >
                Voltar ao login <ArrowRight size={20} />
              </button>
            </div>
          ) : (
            // --- Formulário do CPF ---
            <>
              <div className="form-header">
                <div className="icon-badge">
                  <ShieldCheck size={28} color="#BC0005" />
                </div>
                <h3>Esqueci minha senha</h3>
                <p>Informe seu CPF para receber um link por WhatsApp</p>
              </div>

              <form onSubmit={handleSubmit} className="modern-login-form">
                <div className="input-group">
                  <label htmlFor="cpf">CPF</label>
                  <div className="input-with-icon">
                    <User size={20} className="input-icon" />
                    <input
                      type="text"
                      id="cpf"
                      inputMode="numeric"
                      placeholder="000.000.000-00"
                      value={cpf}
                      onChange={(e) => setCpf(formatarCpf(e.target.value))}
                      required
                    />
                  </div>
                </div>

                <button
                  type="submit"
                  className="btn-primary-login"
                  disabled={enviando || cpf.replace(/\D/g, '').length !== 11}
                >
                  {enviando ? 'Enviando...' : <>Enviar link <ArrowRight size={20} /></>}
                </button>

                <div className="form-actions" style={{ justifyContent: 'center', marginTop: 20, marginBottom: 0 }}>
                  <Link to="/login" className="forgot-link">Voltar ao login</Link>
                </div>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default EsqueciSenha;
